module.exports = __webpack_public_path__ + "static/media/fading.d74539be.mp3";